<template>
  <div>
    <div class="flex items-center mb-4 pt-8">
      <div class="text-xl text-text font-bold">{{ $t('allExpenses') }}</div>
    </div>
    <div class="grid grid-cols-2 col-gap-8">
      <div>
        <div class="text-text font-bold" style="font-size: 3.2rem;">
          {{ displayCurrencyValue(sumFact, spaceCurrency, true, true) }}
        </div>
        <div class="text-sm text-text-ternary">{{ $t('spent') }}</div>
      </div>
      <div class="grid grid-cols-2 col-gap-4 items-end">
        <div class="text-right">
          <div class="text-xl text-text mb-1-5 font-bold">
            {{ displayCurrencyValue(sumPlan, spaceCurrency, false, true) }}
          </div>
          <div class="text-sm text-text-ternary">{{ $t('plan') }}</div>
        </div>
        <div class="text-right">
          <div class="text-xl text-text mb-1-5 font-bold"
               :class="{'text-green':difference > 0,
                        'text-red': difference < 0}">
            {{ displayCurrencyValue(difference, spaceCurrency, false, true) }}
          </div>
          <div class="text-sm text-text-ternary">
            {{ difference >= 0 ? this.$t('availableBalance') : this.$t('overrun') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BudgetsStatExpense",
  props: {
    sumPlan: {
      type: Number
    },
    sumFact: {
      type: Number
    },
    difference:{
      type:Number
    }
  },
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  i18n: {
    messages: {
      en: {
        allExpenses: 'All expenses',
        spent: 'Spent',
        plan: 'Plan',
        overrun: 'Overrun',
        availableBalance: 'Available',
        warningTooltip: 'There are unaccounted transactions in the budget'
      },
      ru: {
        allExpenses: 'Все расходы',
        spent: 'Потрачено',
        plan: 'План',
        overrun: 'Перерасход',
        availableBalance: 'Остаток',
        warningTooltip: 'В бюджете есть неучтенные транзакции'
      }
    }
  }
}
</script>